export enum UserLockType {
  USER_BLOCKED,
  INVITE_NOT_ACCEPTED,
}
